{
  "login": "Login",
  "algorithms": "Algorithms",
  "allowLegacy": "Allow legacy ones",
  "allowLegacyHint": "Needed by switches older than ten years. They enable SHA-1 and CBC mode — for every other node that weakens security for nothing.",
  "hostKeyNotPinned": "The host key is not pinned yet — the platform remembers it on the first connection.",
  "hostKeyLabel": "Host key ({{type}}): ",
  "hostKeyTypeUnknown": "type unknown",
  "hostKeyPinnedAt": "pinned {{at}}",
  "noBanner": "the server did not introduce itself",
  "accepts": "accepts: {{list}}",
  "noSftp": "no SFTP",
  "noOpenTerminals": "No open terminals",
  "noOpenTerminalsHint": "A terminal opens from the network map or the node list: pick a node and press “Terminal”. One machine gets one tab.",
  "tabsOf": "{{open}} of {{max}}",
  "filesOnMachine": "Files on the machine",
  "smaller": "Smaller",
  "bigger": "Bigger",
  "copySelection": "Copy the selection",
  "pasteFromClipboard": "Paste from the clipboard",
  "paste": "Paste",
  "connectingTo": "Connecting to {{name}}…",
  "reconnect": "Reconnect",
  "connectAgain": "Connect again",
  "closedWithCode": "The connection closed, exit code {{code}}",
  "closedInTerminal": "connection closed",
  "closedInTerminalWithCode": "connection closed, exit code {{code}}",
  "bannerHint": "Server identification",
  "routeHint": "How the machine was reached",
  "kexHint": "Key exchange and cipher",
  "legacyAllowed": "legacy algorithms allowed",
  "authMethod": {
    "password": "password",
    "key": "private key",
    "keyboardInteractive": "server dialog (keyboard-interactive)"
  },
  "algorithmKind": {
    "keyExchange": "key exchange",
    "hostKey": "host key",
    "cipher": "cipher",
    "mac": "integrity check (MAC)",
    "compression": "compression",
    "handshake": "handshake"
  },
  "key": {
    "escape": "Escape",
    "tab": "Tab — completion",
    "ctrlC": "Ctrl+C — interrupt",
    "ctrlD": "Ctrl+D — end of input",
    "ctrlZ": "Ctrl+Z — to background",
    "up": "Previous command",
    "down": "Next command",
    "left": "Left",
    "right": "Right",
    "pipe": "Vertical bar",
    "slash": "Slash",
    "tilde": "Tilde"
  },
  "hostKeyChanged": {
    "title": "The host key of {{name}} has changed",
    "explanation": "That is what a server reinstall looks like — and also what an impersonated machine looks like. Until the reason is clear, the platform will not connect and will not send a password to this server. If the server was reinstalled recently, confirm the new key; if it was not, do not confirm and find out what is answering at that address.",
    "was": "Was",
    "now": "Now",
    "keyType": "Key type",
    "checked": "I verified the fingerprint on the machine itself",
    "confirming": "Confirming…",
    "trust": "Trust the new key",
    "forbidden": "Confirming a host key change is for those trusted with credentials. Ask your organization administrator."
  }
}
